import React, { useContext, useState } from "react";
import { Modal, Row, Col } from "react-bootstrap";
import { AuthUserContext } from "../context/context";
import { useTranslation } from "react-i18next";
import PhoneWithGoogle from "../page/phone-wtih-google";

const ChangePhoneModal = ({
  isModalShowChangePhoneNo,
  setIsModalShowChangePhoneNo,
}) => {
  const { currentLocalization } = useContext(AuthUserContext);
  const { t } = useTranslation();
  const [userSignedUp, setUserSignedUp] = useState(false);
  const [login, setLogin] = useState(false);
  const [isModalShow, setIsModalShow] = useState(false);
  const [goolePhoneNoVerification, setGooglePhoneNoVerification] =
    useState(false);
  const handleClose = () => {};
  return (
    <div>
      <Modal
        show={isModalShowChangePhoneNo}
        centered
        className="registration-modal"
        style={{ borderRadius: "8px" }}
      >
        <Modal.Header
          closeButton={false}
          className="custom-header pt-4 -b-4 align-items-center"
        >
          <h2
            className={`login-welcome-registrpopup ${
              currentLocalization == "ar" && "flex-row-reverse"
            }`}
          >
            {t("EnterPhoneNumber")}
          </h2>
          <button
            type="button"
            className="custom-close-btn"
            onClick={() => {
              setIsModalShowChangePhoneNo(false);
            }}
            aria-label="Close"
          >
            &times;
          </button>
        </Modal.Header>

        <Modal.Body className="no-padding">
          <Row>
            <Col>
              <PhoneWithGoogle
                hideSidebar={true}
                isModal={true}
                handleClose={handleClose}
                setIsModalShowChangePhoneNo={setIsModalShowChangePhoneNo}
                setUserSignedUp={setUserSignedUp}
                setGooglePhoneNoVerification={setGooglePhoneNoVerification}
                setLogin={setLogin}
              />
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default ChangePhoneModal;
